<template>
    <div>
        <div class="popFixed" v-if="isFunds">
            <div class="masking" @click="fundsPop"></div>
            <div class="tcCon">
                <div class="item">
                    <p>{{$t("message.insufficientBalance")}}</p>
                    <p>{{$t("message.info_dome1")}}</p>
                </div>
                <div class="btnCon">
                    <span @click="fundsPop">{{$t("message.cancel")}}</span>
                    <span @click="cutOver">{{$t("message.accountSwitch")}}</span>
                </div>
            </div>
        </div>
        <!--真实模拟切换是否成功-->
        <CutOverPop ref="isCut" :errMessage="errMessage"></CutOverPop>
    </div>
</template>

<script>
    import CutOverPop from '@/view/module/CutOverPop.vue'
    import api from '@/plugins/api'
    export default {
        name: "DFundsPop",
        props:['user'],
        components:{CutOverPop},
        data(){
            return{
                isFunds:false,
                errMessage:"",
                langs:''
            }
        },
        methods:{
            fundsPop(){
                this.isFunds=!this.isFunds;
                let mainH = document.getElementById("main");
                mainH.classList.toggle('mainFixed');
            },
            cutOver() {
                this.$bus.$emit('loading', false);
                if (this.locale == "vn") {
                    this.langs = "vi_VN"
                } else {
                    this.langs = "en_US"
                }
                const customer = {
                    customerNumber: this.user.loginname,
                    password: this.user.pwd,
                    mobilePhone: this.user.mobilePhone,
                    mobilePhonePrefix: this.user.mobilePhonePrefix,
                    lang:this.langs
                };
                const readyData = this.$qs.stringify(customer);
                api.transCustomerNumber(readyData).then(res => {
                    if (res.data.code == 200) {
                        const user = {
                            loginname: res.data.data.one_sequence.customerNumber,
                            pwd: res.data.data.one_sequence.encryption,
                            companyId: res.data.data.one_sequence.companyId,
                            mobilePhone: res.data.data.one_sequence.mobilePhone,
                            mobilePhonePrefix:res.data.data.one_sequence.mobilePhonePrefix,
                            token:res.data.data.token,
                            email:res.data.data.one_sequence.email
                        };
                        this.$store.dispatch("setUser", user);
                        window.location.reload(true);
                    }  else if (res.data.code == 501) {
                        window.location.href = res.data.data;
                        this.$bus.$emit('loading', true);
                    }else{
                        this.$bus.$emit('loading', true);
                        this.errMessage = res.data.code_desc;
                        this.$refs.isCut.closePop();
                    }
                })
            },
        }
    }
</script>
